import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      is_screen_lock: "layout/is_screen_lock"
    })
  },
  watch: {
    is_screen_lock(value) {
      if (value) document.title = "Locked " + document.title;
      else document.title = document.title.replace("Locked ", "");
    }
  },
  beforeMount() {
    const title = getTitle(this);
    if (title) document.title = title + " - DPauls IMS";
  }
};

function getTitle(vm) {
  const { title } = vm.$options;
  if (title) return typeof title === "function" ? title.call(vm) : title;
}
